// https://stackoverflow.com/questions/154059/how-can-i-check-for-an-empty-undefined-null-string-in-javascript
export const isBlank = str => {
  return !str || /^\s*$/.test(str);
};

export const isNotBlank = str => !isBlank(str);
